import React from "react";
import { Link, useLocation } from "react-router-dom";
import Steps from "../../components/common/steps";
import { ReactComponent as BackIcon } from "./../../assets/icons/back.svg";
import { useDispatch } from "react-redux";
import { currentValue } from "../../store/slices/stepsSlice";

const Layout = ({
  heading,
  page,
  curr,
  isPayment,
  isTeamInvite,
  isAddDeals,
}) => {
  const dispatch = useDispatch();
  const location = useLocation();
  const containsInvite = location.pathname.includes("/invite");

  return (
    <>
      <div className="lg:grid lg:grid-cols-3 lg:mt-2 lg:overflow-x-hidden">
        <div className="hidden lg:flex lg:justify-center">
          <Steps
            current={curr}
            onChange={(value) => {
              dispatch(currentValue(value));
            }}
          />
        </div>
        <div className="col-span-2 h-screen">
          <div className="w-full hidden lg:block lg:px-5">
            <p className="flex items-center text-heading font-medium">
              <Link
                to={
                  isTeamInvite
                    ? ""
                    : isAddDeals
                    ? "/invite"
                    : isPayment
                    ? "/deal"
                    : ""
                }
              >
                {!containsInvite && <BackIcon />}
              </Link>
              <span className="ml-2">{heading}</span>
            </p>
          </div>
          <div className="">{page}</div>
        </div>
      </div>
    </>
  );
};

export default Layout;
